export default __webpack_public_path__ + "static/media/number-9.b76645c7.svg";